export class CustomerLocation {
    readonly id?: number
    email: string = ''
    apartment?: string
    street_number?: string
    street: string = ''
    city: string = ''
    state: string = ''
    zip: string = ''
    lat?: string
    lng?: string
    phone: string = ''
    phone_ext?: string
    phone2?: string
    phone_ext2?: string
    primary: boolean = false
    location_type: string = ''
    contact_role: string = ''
}